import { useTranslation } from "react-i18next";

import {
  useI18audioContextDetails,
  useI18audioContextValue,
  useI18permissionsValue,
} from "../../../../../hooks";

export const useMockDataJS = () => {
  const { t } = useTranslation();

  const { permissionsValue } = useI18permissionsValue(t);
  const { audioContextValue } = useI18audioContextValue(t);
  const { audioContextDetails } = useI18audioContextDetails(t);

  return [
    {
      id: "userAgentJs",
      attribute: t("scannerFingerprint.JS.userAgentJS"),
      ratio: 0.34,
      value: "-",
      type: "default",
      clue: t("scannerFingerprint.JS.userAgentJSClue"),
    },
    {
      id: "os",
      attribute: t("scannerFingerprint.JS.os"),
      ratio: 36.7,
      value: "-",
      type: "default",
      clue: t("scannerFingerprint.JS.osClue"),
    },
    {
      id: "cookie",
      attribute: t("scannerFingerprint.JS.cookie"),
      ratio: 90.36,
      value: "-",
      type: "icon",
      clue: t("scannerFingerprint.JS.cookieClue"),
    },
    {
      id: "timeZone",
      attribute: t("scannerFingerprint.JS.timeZone"),
      ratio: 1.63,
      value: "-",
      type: "default",
      clue: t("scannerFingerprint.JS.timeZoneClue"),
    },
    {
      id: "languageJs",
      attribute: t("scannerFingerprint.JS.languageJs"),
      ratio: 0.0,
      value: "-",
      type: "default",
      clue: t("scannerFingerprint.JS.languageJsClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.canvass"),
      ratio: 0.0,
      value: t("global.78"),
      type: "default",
      clue: t("scannerFingerprint.JS.canvassClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.fonts"),
      ratio: 0.0,
      value: [
        "Arial",
        "Arial Unicode MS",
        "Spendthrift",
        "Arial Black",
        t("global.others78"),
      ],
      type: "list",
      clue: t("scannerFingerprint.JS.fontsClue"),
    },
    {
      id: "adblock",
      attribute: t("scannerFingerprint.JS.adblock"),
      ratio: 26.38,
      value: true,
      type: "icon",
      clue: t("scannerFingerprint.JS.adblockClue"),
    },
    {
      id: "doNotTrack",
      attribute: t("scannerFingerprint.JS.doNotTrack"),
      ratio: 65.05,
      value: true,
      type: "icon",
      clue: t("scannerFingerprint.JS.doNotTrackClue"),
    },
    {
      id: "buildID",
      attribute: t("scannerFingerprint.JS.buildID"),
      ratio: 56.34,
      value: t("global.notSupported"),
      type: "default",
      clue: t("scannerFingerprint.JS.buildIDClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.product"),
      ratio: 91.09,
      value: "Gecko",
      type: "default",
      clue: t("scannerFingerprint.JS.productClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.productSub"),
      ratio: 56.04,
      value: "20030107",
      type: "default",
      clue: t("scannerFingerprint.JS.productSubClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.vendor"),
      ratio: 48.13,
      value: "Google Inc",
      type: "default",
      clue: t("scannerFingerprint.JS.vendorClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.vendorSub"),
      ratio: 91.27,
      value: t("global.noValue"),
      type: "default",
      clue: t("scannerFingerprint.JS.vendorSubClue"),
    },
    {
      id: "hardware",
      attribute: t("scannerFingerprint.JS.hardware"),
      ratio: 23.64,
      value: "12",
      type: "default",
      clue: t("scannerFingerprint.JS.hardwareClue"),
    },
    {
      id: "java",
      attribute: t("scannerFingerprint.JS.java"),
      ratio: 91.07,
      value: true,
      type: "icon",
      clue: t("scannerFingerprint.JS.javaClue"),
    },
    {
      id: "deviceMemory",
      attribute: t("scannerFingerprint.JS.memory"),
      ratio: 32.66,
      value: "-",
      type: "default",
      clue: t("scannerFingerprint.JS.memoryClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.plugins"),
      ratio: 24.38,
      value:
        "Plugin 0: PDF Viewer (Portable Document Format). Plugin 1: Chrome PDF Viewer (Portable Document Format). Plugin 2: Chromium PDF Viewer (Portable Document Format). Plugin 3: Microsoft Edge PDF Viewer (Portable Document Format). Plugin 4: WebKit built-in PDF (Portable Document Format).",
      type: "default",
      clue: t("scannerFingerprint.JS.pluginsClue"),
    },
    {
      id: "screenWidth",
      attribute: t("scannerFingerprint.JS.screenWidth"),
      ratio: 4.52,
      value: "-",
      type: "default",
      clue: t("scannerFingerprint.JS.screenWidthClue"),
    },
    {
      id: "screenHeight",
      attribute: t("scannerFingerprint.JS.screenHeight"),
      ratio: 4.15,
      value: "-",
      type: "default",
      clue: t("scannerFingerprint.JS.screenHeightClue"),
    },
    {
      id: "color",
      attribute: t("scannerFingerprint.JS.screenDepth"),
      ratio: 81.84,
      value: "-",
      type: "default",
      clue: t("scannerFingerprint.JS.screenDepthClue"),
    },
    {
      id: "availableTop",
      attribute: t("scannerFingerprint.JS.availableTop"),
      ratio: 79.22,
      value: "0",
      type: "default",
      clue: t("scannerFingerprint.JS.availableTopClue"),
    },
    {
      id: "availableLeft",
      attribute: t("scannerFingerprint.JS.availableLeft"),
      ratio: 83.63,
      value: "0",
      type: "default",
      clue: t("scannerFingerprint.JS.availableLeftClue"),
    },
    {
      id: "availableHeight",
      attribute: t("scannerFingerprint.JS.availableHeight"),
      ratio: 1.39,
      value: "1040",
      type: "default",
      clue: t("scannerFingerprint.JS.availableHeightClue"),
    },
    {
      id: "availableWidth",
      attribute: t("scannerFingerprint.JS.availableWidth"),
      ratio: 4.46,
      value: "1920",
      type: "default",
      clue: t("scannerFingerprint.JS.availableWidthClue"),
    },
    {
      id: "permissions",
      attribute: t("scannerFingerprint.JS.permissions"),
      ratio: 3.36,
      // value: t("scannerFingerprint.JS.permissionsValue", {
      //   returnObjects: true,
      // }),
      value: permissionsValue,
      type: "list objects",
      clue: t("scannerFingerprint.JS.permissionsClue"),
    },
    {
      id: "webGLVendor",
      attribute: t("scannerFingerprint.JS.webGLVendor"),
      ratio: 12.29,
      value: "-",
      type: "default",
      clue: t("scannerFingerprint.JS.webGLVendorClue"),
    },
    {
      id: "webGLRenderer",
      attribute: t("scannerFingerprint.JS.webGLRenderer"),
      ratio: 0.37,
      value: "-",
      type: "default",
      clue: t("scannerFingerprint.JS.webGLRendererClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.webGLData"),
      ratio: 0.86,
      value: "icon-triangle",
      type: "triangle",
      clue: t("scannerFingerprint.JS.webGLDataClue"),
    },
    {
      id: "webGLParameters",
      attribute: t("scannerFingerprint.JS.webGLParameters"),
      ratio: 1.42,
      value: [
        { indicator: "29", description: "different extensions" },
        {
          indicator: "25",
          description: "different general parameters analyzed",
        },
        {
          indicator: "36",
          description: "different shaders precisions analyzed",
        },
      ],
      type: "list objects",
      clue: t("scannerFingerprint.JS.webGLParametersClue"),
    },
    {
      id: "localStorageSupported",
      attribute: t("scannerFingerprint.JS.useOfLocalStorage"),
      ratio: 90.02,
      value: false,
      type: "icon",
      clue: t("scannerFingerprint.JS.useOfLocalStorageClue"),
    },
    {
      id: "sessionStorageSupported",
      attribute: t("scannerFingerprint.JS.useOfSessionStorage"),
      ratio: 90.12,
      value: false,
      type: "icon",
      clue: t("scannerFingerprint.JS.useOfSessionStorageClue"),
    },
    {
      id: "indexedDBSupported",
      attribute: t("scannerFingerprint.JS.useOfIndexedDB"),

      ratio: 90.92,
      value: false,
      type: "icon",
      clue: t("scannerFingerprint.JS.useOfIndexedDBClue"),
    },
    {
      id: "audioFormats",
      attribute: t("scannerFingerprint.JS.audioFormats"),
      ratio: 33.97,
      clue: t("scannerFingerprint.JS.audioFormatsClue"),
      value: [
        { id: "audio/aac", indicator: "audio/aac", description: "-" },
        { id: "audio/flac", indicator: "audio/flac", description: "-" },
        { id: "audio/mpeg", indicator: "audio/mpeg", description: "-" },
        {
          id: 'audio/ogg; codecs="flac"',
          indicator: 'audio/ogg; codecs="flac"',
          description: "-",
        },
        {
          id: 'audio/ogg; codecs="vorbis"',
          indicator: 'audio/ogg; codecs="vorbis"',
          description: "-",
        },
        {
          id: 'audio/ogg; codecs="opus"',
          indicator: 'audio/ogg; codecs="opus"',
          description: "-",
        },
        {
          id: 'audio/wav; codecs="1"',
          indicator: 'audio/wav; codecs="1"',
          description: "-",
        },
        {
          id: 'audio/webm; codecs="vorbis"',
          indicator: 'audio/webm; codecs="vorbis"',
          description: "-",
        },
        {
          id: 'audio/webm; codecs="opus"',
          indicator: 'audio/webm; codecs="opus"',
          description: "-",
        },
        {
          id: 'audio/mp4; codecs="mp4a_40_2"',
          indicator: 'audio/mp4; codecs="mp4a_40_2"',
          description: "-",
        },
      ],
      type: "list objects",
    },
    {
      id: "audioContext",
      attribute: t("scannerFingerprint.JS.audioContext"),
      ratio: 8.59,
      // value: t("scannerFingerprint.JS.audioContextValue", {
      //   returnObjects: true,
      // }),
      value: audioContextValue,
      type: "list objects",
      clue: t("scannerFingerprint.JS.audioContextClue"),
    },
    {
      id: "analyser",
      attribute: t("scannerFingerprint.JS.frequencyAnalyser"),
      ratio: 75.95,
      // value: t("scannerFingerprint.JS.audioContextDetails", {
      //   returnObjects: true,
      // }),
      value: audioContextDetails,
      type: "list objects",
      clue: t("scannerFingerprint.JS.frequencyAnalyserClue"),
    },
    {
      attribute: t("scannerFingerprint.JS.audioData"),
      ratio: 56.81,
      value: t("global.notSupported"),
      type: "default",
      clue: t("scannerFingerprint.JS.audioDataClue"),
    },
    {
      id: "videoFormats",
      attribute: t("scannerFingerprint.JS.videoFormats"),
      ratio: 13.71,
      clue: t("scannerFingerprint.JS.videoFormatsClue"),
      value: [
        {
          id: 'video/mp4; codecs="flac"',
          indicator: 'video/mp4; codecs="flac"',
          description: "-",
        },
        {
          id: 'video/ogg; codecs="theora"',
          indicator: 'video/ogg; codecs="theora"',
          description: "-",
        },
        {
          id: 'video/ogg; codecs="opus"',
          indicator: 'video/ogg; codecs="opus"',
          description: "-",
        },
        {
          id: 'video/webm; codecs="vp9, opus"',
          indicator: 'video/webm; codecs="vp9, opus"',
          description: "-",
        },
        {
          id: 'video/webm; codecs="vp8, vorbis"',
          indicator: 'video/webm; codecs="vp8, vorbis"',
          description: "-",
        },
      ],
      type: "list objects",
    },
    {
      id: "mediaDevices",
      attribute: t("scannerFingerprint.JS.mediaDevices"),
      ratio: 10.49,
      value: [t("global.notSupported")],
      type: "list",
      clue: t("scannerFingerprint.JS.mediaDevicesClue"),
    },
    {
      id: "accelerometer",
      attribute: t("scannerFingerprint.JS.accelerometer"),
      ratio: 84.15,
      value: false,
      type: "icon",
      clue: t("scannerFingerprint.JS.accelerometerClue"),
    },
    {
      id: "gyroscope",
      attribute: t("scannerFingerprint.JS.gyroscope"),
      ratio: 17.56,
      value: false,
      type: "icon",
      clue: t("scannerFingerprint.JS.gyroscopeClue"),
    },
    {
      id: "proximitySensor",
      attribute: t("scannerFingerprint.JS.proximitySensor"),
      ratio: 86.01,
      value: false,
      type: "icon",
      clue: t("scannerFingerprint.JS.proximitySensorClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.keyboardLayout"),
      ratio: 8.61,
      value: t("global.other"),
      type: "default",
      clue: t("scannerFingerprint.JS.keyboardLayoutClue"),
    },
    {
      id: "battery",
      attribute: t("scannerFingerprint.JS.battery"),
      ratio: 44.99,
      value: t("global.notSupported"),
      type: "default",
      clue: t("scannerFingerprint.JS.batteryClue"),
    },
    {
      id: "connection",
      attribute: t("scannerFingerprint.JS.connection"),
      clue: t("scannerFingerprint.JS.connectionClue"),
      ratio: 2.83,
      value: [
        { id: "downlink", indicator: "downlink", description: "10" },
        { id: "effectiveType", indicator: "effectiveType", description: "4g" },
        { id: "rtt", indicator: "rtt", description: "50" },
        { id: "saveData", indicator: "saveData", description: "false" },
      ],
      type: "list objects",
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.key"),
      ratio: 32.56,
      value: t("global.noValue"),
      type: "default",
      clue: t("scannerFingerprint.JS.keyClue"),
    },
    {
      id: "locationBar",
      attribute: t("scannerFingerprint.JS.locationBar"),
      ratio: 90.97,
      value: true,
      type: "icon",
      clue: t("scannerFingerprint.JS.locationBarClue"),
    },
    {
      id: "menuBar",
      attribute: t("scannerFingerprint.JS.menuBar"),
      ratio: 91.0,
      value: true,
      type: "icon",
      clue: t("scannerFingerprint.JS.menuBarClue"),
    },
    {
      id: "personalBar",
      attribute: t("scannerFingerprint.JS.personalBar"),
      ratio: 90.98,
      value: true,
      type: "icon",
      clue: t("scannerFingerprint.JS.personalBarClue"),
    },
    {
      id: "statusBar",
      attribute: t("scannerFingerprint.JS.statusBar"),
      ratio: 90.98,
      value: true,
      type: "icon",
      clue: t("scannerFingerprint.JS.statusBarClue"),
    },
    {
      id: "toolBar",
      attribute: t("scannerFingerprint.JS.toolBar"),
      ratio: 90.98,
      value: false,
      type: "icon",
      clue: t("scannerFingerprint.JS.toolBarClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.resultState"),
      ratio: 91.18,
      value: t("global.noValue"),
      type: "default",
      clue: t("scannerFingerprint.JS.resultStateClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.listOfFontsFlash"),
      ratio: 91.03,
      value: t("global.notDetected"),
      type: "default",
      clue: t("scannerFingerprint.JS.listOfFontsFlashClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.screenResolutionFlash"),
      ratio: 91.03,
      value: t("global.notDetected"),
      type: "default",
      clue: t("scannerFingerprint.JS.screenResolutionFlashClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.languageFlash"),
      ratio: 91.03,
      value: t("global.notDetected"),
      type: "default",
      clue: t("scannerFingerprint.JS.languageFlashClue"),
    },
    {
      id: "",
      attribute: t("scannerFingerprint.JS.platformFlash"),
      ratio: 91.03,
      value: t("global.notDetected"),
      type: "default",
      clue: t("scannerFingerprint.JS.platformFlashClue"),
    },
  ];
};
